import { render, staticRenderFns } from "./Selete.vue?vue&type=template&id=ed66baa0"
import script from "./Selete.vue?vue&type=script&lang=js"
export * from "./Selete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports